import Trustpilot from '~components/Trustpilot/Trustpilot';
import GridNeo from '~components/_layout/GridNeo/GridNeo';
import Section from '~components/_layout/Section';
import BBB from '~images/inline/BBB.inline.svg';

type Props = {
    bgcolor: string;
    heroimage: string;
    titletext: string;
};

export default function NewHero({
    children,
    bgcolor = 'gray-lightest',
    heroimage,
    titletext,
}: React.PropsWithChildren<Props>) {
    return (
        <Section extraClasses={`bg-${bgcolor}`}>
            <GridNeo extraClasses="pt-3">
                <div className="hidden lg:block col-span-full md:col-span-4 lg:col-span-6 relative">
                    {heroimage && (
                        <img
                            src={heroimage}
                            alt=""
                            className="absolute bottom-0 right-0 max-w-[486px]"
                        />
                    )}
                    <div className="hidden lg:flex absolute bottom-12 right-44 justify-center items-center md:bg-white py-2 px-3 md:rounded-full md:bg-opacity-80">
                        <div className="mr-6">
                            <div
                                className="norton-placeholder"
                                id="DigiCertClickID_onwANETs_7"
                            ></div>
                        </div>
                        <a
                            href="https://www.bbb.org/us/ca/santa-clara/profile/insurance-companies/ehealthinsurance-services-1216-359700#bbbseal"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="BBB Accredited Business, BBB rating A plus"
                        >
                            <BBB width={58} height={40} />
                        </a>
                    </div>
                </div>
                <div className="hidden lg:flex absolute bottom-12 right-44 justify-center items-center md:bg-white py-2 px-3 md:rounded-full md:bg-opacity-80">
                    <div className="mr-6">
                        <div className="norton-placeholder" id="DigiCertClickID_onwANETs_8"></div>
                    </div>
                    <a
                        href="https://www.bbb.org/us/ca/santa-clara/profile/insurance-companies/ehealthinsurance-services-1216-359700#bbbseal"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="BBB Accredited Business, BBB rating A plus"
                    >
                        <BBB width={58} height={40} />
                    </a>
                </div>
                <div className="col-span-full md:col-span-6 md:col-start-2 lg:col-span-6 items-center flex flex-col">
                    <h1 className="text-32 leading-40 md:text-40 md:leading-56 lg:text-48 lg:leading-65 font-bold text-black">
                        {titletext}
                    </h1>

                    <div className="bg-white p-6 rounded-lg shadow-lg shadow-gray-light w-full mb-4">
                        {children}
                        <div className="flex justify-center mt-2 lg:hidden">
                            <div className="mr-6">
                                <div
                                    className="norton-placeholder"
                                    id="DigiCertClickID_onwANETs_9"
                                ></div>
                            </div>
                            <div>
                                <a
                                    href="https://www.bbb.org/us/ca/santa-clara/profile/insurance-companies/ehealthinsurance-services-1216-359700#bbbseal"
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label="BBB Accredited Business, BBB rating A plus"
                                >
                                    <BBB width={65} height={44} />
                                </a>
                            </div>
                        </div>
                        <Trustpilot size="newthin" className="py-4 print:hidden" />
                    </div>
                </div>
            </GridNeo>
        </Section>
    );
}
